/******************************************************************************
 * App configuration
 *****************************************************************************/
export const APP_NAME =
    "Zählerstand Zähler ablesen - Eure Stadtwerke Brunsbüttel";
export const APP_SHORT_NAME = "Ableseportal";
export const APP_DESCRIPTION =
    "Geben Sie uns Ihren Zählerstand einfach online durch!";
export const CLIENT_FULL = "Stadtwerke Brunsbüttel GmbH";
export const CLIENT_SHORT = "Stadtwerke Brunsbüttel";
export const FALLBACK_PRECOMMA_DIGITS = 7;
export const URLS = {
    website: "https://www.stadtwerke-brunsbuettel.de",
    privacy: "https://www.stadtwerke-brunsbuettel.de/datenschutz.html",
    imprint: "https://www.stadtwerke-brunsbuettel.de/impressum.html",
};
export const LENGTH_IMPLAUSIBLE_REASON_OTHER = 200;
export const ERROR_MESSAGES = {
    error429: "😡 Zuviele Anfragen. Bitte versuchen Sie es in Kürze erneut.",
    error500:
        "😓 Beim Verarbeiten Ihrer Anfrage ist ein Fehler aufgetreten. Bitte kontaktieren Sie unseren Kundenservice.",
};
